import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getPageHeader, updatePageHeader } from "../api/pageApi";
import toast from "react-hot-toast";
import { useEffect } from "react";

export const usePageHeader = () => {
  const queryClient = useQueryClient();

  // Fetch page header
  const { data: pageHeader, isLoading, error } = useQuery({
    queryKey: ["pageHeader"],
    queryFn: getPageHeader,
    
  });

  // Mutation for updating page header
  const updateHeaderMutation = useMutation({
    mutationFn: ({ key, h1, tagline, content }) => updatePageHeader(key, h1, tagline, content),
    onSuccess: (data) => {
      toast.success(data.message || "Page header updated successfully");
      queryClient.invalidateQueries(["pageHeader"]); // Refetch page header after update
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Failed to update page header");
    }
  });

  useEffect(() => {
    if (error) {
      toast.error(error.response?.data?.message || "Failed to fetch page header");
    }
  }, [error]);

  return {
    pageHeader,
    isLoading,
    updatePageHeader: updateHeaderMutation.mutate,
    isUpdating: updateHeaderMutation.isLoading,
  };
}